$(document).ready(function () {

    if ($('#table-gifts').length) {

        const urlPromotions = window.location.origin + '/admin/gift-promotions/get';

        $("#add-gift").on('click', function () {

            $.ajax({
                url: window.location.origin + '/admin/gift-promotions/create',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal').innerHTML = response;
                    $('#modal-gift').modal("show");
                    $('.chosen-select').chosen({width: '100%'});

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        })

        $(document).on('click', '#send_gift', function (event) {
            event.preventDefault();

            let url = window.location.origin + '/admin/gift-promotions';
            let form = document.getElementById('form-gift');
            let formData = new FormData(form);
            document.getElementById('div_message').innerHTML = "";

            $.ajax({
                data: formData,
                url: url,
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    if (response.success) {
                        swal.fire('Agregado', response.message, 'success')
                            .then(() => {
                                $('#modal-gift').modal("hide");
                                $('#table-gifts').DataTable().ajax.url(urlPromotions).load();
                                getPreview();
                            });
                    } else {
                        swal.fire('Error', response.message, 'error');
                    }
                })
                .fail(function (jqXHR, textStatus) {
                    handleAjaxError(jqXHR);
                });
        });

        $(document).on('click', '#send_gift_update', function (event) {

            event.preventDefault();
            let id = $("#gift_id").val();
            let url = window.location.origin + '/admin/gift-promotions/' + id;

            let form = document.getElementById('form-gift');
            let formData = new FormData(form);
            formData.append('_method', 'PUT');
            document.getElementById('div_message').innerHTML = "";

            $.ajax({
                data: formData,
                url: url,
                type: 'POST',
                contentType: false,
                processData: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {

                    if (typeof response['status'] !== 'undefined') {
                        swal.fire('Advertencia', response['message'], 'info')
                            .then(() => {
                                location.reload();
                            });
                    } else {
                        swal.fire('Actualizado', 'Se actualizo el regalo correctamente', 'success')
                            .then(() => {
                                $('#modal-gift').modal("hide");
                                $('#table-gifts').DataTable().ajax.url(urlPromotions).load();
                                getPreview();
                            });
                    }

                })
                .fail(function (jqXHR, textStatus) {
                    handleAjaxError(jqXHR);
                });
        });

        $('#table-gifts').dataTable({
            "processing": true,
            "serverSide": true,
            "ajax": urlPromotions,
            "columns": [
                {data: 'description'},
                {data: 'type'},
                {data: 'minimum_amount'},
                {data: 'start_date'},
                {data: 'end_date'},
                {data: 'stock'},
                {data: 'status'},
                {data: null},
            ],
            "order": [[1, 'desc']],
            "columnDefs": [
                //{ targets: 0, width: '30%' },
                {
                    "targets": 6,
                    "render": function (data, type, row, meta) {
                        if (row.status === 'A') {
                            return "<span class='badge badge-success'><big>Activo</big></span>";
                        } else {
                            return "<span class='badge badge-danger'><big>Inactivo</big></span>";
                        }
                    }
                },
                {
                    "targets": 7,
                    "render": function (data, type, row, meta) {

                        return "<button type='button' class='btn btn-primary btn-sm edit-gifts' data-customer='" + row + "' data-bs-toggle='tooltip' title='Editar Regalo'><i class='fas fa-pencil-alt'></i></button> "
                            + "<button type='button' class='btn btn-danger btn-sm remove-gifts' data-customer='" + row + "' data-bs-toggle='tooltip' title='Eliminar Regalo'><i class='fas fa-trash'></i></button>";

                    }
                },
            ],
            "language": {
                url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
            },
        });

        $('#table-gifts').on('draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });

        $('#table-gifts tbody').on('click', '.edit-gifts', function (e) {
            e.preventDefault();
            let table = $("#table-gifts").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/admin/gift-promotions/' + rowData.id + '/edit',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-gift').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });

        $('#table-gifts tbody').on('click', '.remove-gifts', function (e) {
            e.preventDefault();
            let table = $("#table-gifts").DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            swal
                .fire({
                    title: "Eliminar regalo : " + rowData.description,
                    text: "¿Eliminar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        let url = window.location.origin + '/admin/gift-promotions/' + rowData.id;
                        $.ajax({
                            url: url,
                            type: 'DELETE',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                swal.fire('Eliminado', 'Se ha eliminado el regalo.', 'success')
                                    .then(() => {
                                        $('#table-gifts').DataTable().ajax.url(urlPromotions).load();
                                        getPreview();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });

    }

    function  getPreview(){
        $.ajax({
            url: window.location.origin + '/admin/gift-promotions/get/preview',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_show_gifts').innerHTML = response;
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    }

})
